import CreateWorkflowController from './create-workflow-modal.controller';

const CreateWorkflow = (props: any) => {
  return <CreateWorkflowController {...props} />;
};

export default CreateWorkflow;
